import { Component, OnInit,ViewChild,TemplateRef,Input, group } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { TestSeriesService } from '../../service/test-series.service';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { FileSelectDirective,FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals} from '../.././globals';
import { commonService } from '../../service/common.service';
@Component({
  selector: 'app-paymentsuccess',
  templateUrl: './paymentsuccess.component.html',
  styleUrls: ['./paymentsuccess.component.css'],
  providers:[TestSeriesService]
})
export class PaymentsuccessComponent implements OnInit {

  userData:any;
  txnid:any;
  paymnetstatus:any;
  constructor(private TestSeriesService:TestSeriesService,private _common:commonService,private router:Router,private route:ActivatedRoute) { }

  ngOnInit() {
   this.route.params.subscribe(params => {
        this.txnid = params.id; 
   })
        // get user details
  this._common.profile.subscribe((data:any)=>{
    if(data){
    this.userData = data;
    }else{
    this.userData={};
    
    }
    })

    this.getpaymnetstatus();
  }

  getpaymnetstatus(){
    let obj={}
    obj['userId']=(this.userData.id)?this.userData.id:0;
    obj['txnid'] = this.txnid;

    
    this.TestSeriesService.getpaymnetstatus(obj).subscribe((data:any)=>{
          if(data.error==0){
           this.paymnetstatus= data.results;
          
          }else{

            this.router.navigate(['/']);
          }

    },(error:HttpErrorResponse)=>{
     // this.msg="internal server error!";
    })
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/paymentsuccess/paymentsuccess.component.ts